import { useState, useEffect } from "react";
import { createModel } from "hox";
import { TablePaginationConfig } from "antd/es/table/interface";
import { IPgProps, ISearchPage } from "@/types/ScmTypes";
import { DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE, } from "@/utils/constants";
import { soReportService, IVRMSoReportSearchFields, IVRMSoReportDetail, IStatistics } from "./soReportService";
import useGlobalModel from "@/model/globalModel";
import { convertRes2Blob } from "@/utils/exportFile";
import { transPgToPagination } from "@/utils/utils";
import { isArray } from "util";


export const useSoReportModel = createModel(function () {
    const initStatistics = {
        saleNum: 0,
        saleAmount: 0,
        giftsNum: 0,
        giftsAmount: 0,
        costAmount: 0,
        profit: 0
    }
    const { shopAndOrg: { shopId, shopType }, setLoadingInfo } = useGlobalModel();
    const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }

    //查询条件
    const [searchParam, setSearchParam] = useState<IVRMSoReportSearchFields>({});
    //列表数据源
    const [dataSource, setDataSource] = useState<IVRMSoReportDetail[]>([]);
    //表格选中行Key值
    const [selectedRowKeys, setSelectedRowKeys] = useState<string[]>([]);
    //列表数据源分页参数
    const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg);
    const [loading, setLoading] = useState<boolean>(false);
    const [descTotal, setDescTotal] = useState<IStatistics>(initStatistics);
    const updateSearchParam = (updateParam: IVRMSoReportSearchFields) => {
        setSearchParam({ ...searchParam, ...updateParam })
    }

    //重置
    const resetSearchParam = () => {
        setSearchParam({});
        setSelectedRowKeys([]);
        loadData(initPgCfg, {});
    }

    const loadData = async (page?: ISearchPage, searchValue: IVRMSoReportSearchFields = searchParam) => {
        setLoading(true);
        const shopParam = {
            shopType: searchValue.shopId !== undefined ? 1 : shopType,
            shopId: searchValue.shopId ?? shopId
        };
        const searchParams = {
            ...searchValue,
            ...shopParam,
            tradeTypeCode: isArray(searchValue?.tradeTypeCode) ? searchValue?.tradeTypeCode.join() : searchValue?.tradeTypeCode,
            startTime: searchValue?.startTime ? searchValue?.startTime.replace(/T/g, " ") : "",
            endTime: searchValue?.endTime ? searchValue?.endTime.replace(/T/g, " ") : "",
            pageSize: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
            pageNum: (page?.current || page?.pageNum) ?? pgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
        }
        let { retData } = await soReportService.page(searchParams);
        const { records, ...pg } = retData;
        setPgCfg(transPgToPagination(pg));
        setDataSource(origin =>
            records?.map((item, index) => ({ ...item, id: index + "1" })));
        setLoading(false);
        // loadTotal(searchParams);

    }
    const loadTotal = async (searchParams: any) => {
        let { retData: statistics } = await soReportService.statistics(searchParams);
        setDescTotal(statistics)
    }
    //导出
    const exportSoReport = async (searchValue: IVRMSoReportSearchFields = searchParam) => {
        setLoadingInfo({ loadingVisible: true, txt: "快速导出中" })

        try {
            const shopParam = {
                shopType: searchValue.shopId !== undefined ? 1 : shopType,
                shopId: searchValue.shopId ?? shopId
            };
            const searchParams = {
                ...searchValue,
                ...shopParam,
                tradeTypeCode: isArray(searchValue?.tradeTypeCode) ? searchValue?.tradeTypeCode.join() : searchValue?.tradeTypeCode,
                id: selectedRowKeys.join(),
                pageSize: -1,
                pageNum: 1,
            }
            let result = await soReportService.export(searchParams);
            result && setLoadingInfo({ loadingVisible: false, txt: "" });
            convertRes2Blob(result);
        } catch {
            setLoadingInfo({ loadingVisible: false, txt: "" });
        }
    }
    const [historyVisible, setHistoryVisible] = useState<boolean>(false)
    const [historyRow, setHistoryRow] = useState<IVRMSoReportDetail>()
    return {
        /***field***/
        searchParam,
        dataSource,
        selectedRowKeys,
        pgCfg, loading,
        /***method***/
        setDataSource,
        setSelectedRowKeys,
        resetSearchParam,
        updateSearchParam,
        loadData, exportSoReport,
        descTotal, setDescTotal,
        historyVisible, setHistoryVisible,
        historyRow, setHistoryRow,
    }
});


